{
  "actionbar.actions": "Handlinger",
  "actionbar.actionsAvailable": "Tilgjengelige handlinger.",
  "actionbar.clearSelection": "Tøm utvalg",
  "actionbar.selected": "Valde element: {count}",
  "actionbar.selectedAll": "Alle er valgt",
  "breadcrumbs.more": "Flere elementer",
  "button.pending": "avventer",
  "calendar.invalidSelection": "Valgt(e) {selectedCount, plural, one {dato} other {datoer}} er utilgjengelig.",
  "combobox.noResults": "Ingen resultater",
  "contextualhelp.help": "Hjelp",
  "contextualhelp.info": "Informasjon",
  "datepicker.endTime": "Sluttid",
  "datepicker.startTime": "Starttid",
  "datepicker.time": "Tid",
  "dialog.alert": "Varsel",
  "dialog.dismiss": "Lukk",
  "dropzone.replaceMessage": "Slipp filen for å erstatte",
  "inlinealert.informative": "Informasjon",
  "inlinealert.negative": "Feil",
  "inlinealert.notice": "Advarsel",
  "inlinealert.positive": "Vellykket",
  "label.(optional)": "(valgfritt)",
  "label.(required)": "(obligatorisk)",
  "menu.moreActions": "Flere handlinger",
  "notificationbadge.indicatorOnly": "Ny aktivitet",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Velg …",
  "picker.selectedCount": "{count, plural, =0 {Ingen elementer er valgt} one {# element er valgt} other {# elementer er valgt}}",
  "slider.maximum": "Maksimum",
  "slider.minimum": "Minimum",
  "table.loading": "Laster inn...",
  "table.loadingMore": "Laster inn flere...",
  "table.resizeColumn": "Endre størrelse på kolonne",
  "table.sortAscending": "Sorter stigende",
  "table.sortDescending": "Sorter synkende",
  "tag.actions": "Handlinger",
  "tag.hideButtonLabel": "Vis mindre",
  "tag.noTags": "Ingen",
  "tag.showAllButtonLabel": "Vis alle ({tagCount, number})",
  "toast.clearAll": "Fjern alle",
  "toast.collapse": "Skjul",
  "toast.showAll": "Vis alle"
}
